const PIXEL_ID = '2177547493069894'

declare global {
  interface Window {
    fbq: (...args: unknown[]) => void
    _fbq: (...args: unknown[]) => void
  }
}

export function initPixel() {
  if (typeof window === 'undefined' || window.fbq) return

  const f = window
  const b = document
  const n = 'script'

  f.fbq = function (...args: unknown[]) {
    if ((f.fbq as any).callMethod) {
      ;(f.fbq as any).callMethod(...args)
    } else {
      ;(f.fbq as any).queue.push(args)
    }
  }

  if (!f._fbq) f._fbq = f.fbq
  ;(f.fbq as any).push = f.fbq
  ;(f.fbq as any).loaded = true
  ;(f.fbq as any).version = '2.0'
  ;(f.fbq as any).queue = []

  const script = b.createElement(n) as HTMLScriptElement
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'

  const firstScript = b.getElementsByTagName(n)[0]
  firstScript?.parentNode?.insertBefore(script, firstScript)

  window.fbq('init', PIXEL_ID)
}

export function trackPageView() {
  if (window.fbq) {
    window.fbq('track', 'PageView')
  }
}

export function trackLead(data?: Record<string, string>) {
  if (window.fbq) {
    window.fbq('track', 'Lead', data)
  }
}
